<template>
  <div>
    <el-tabs v-model="activeTabName" type="card">
      <el-tab-pane :label="$t('m.join_agency_apply')" name="join">
        <join-guild-management-page v-if="shouldTabShow('join')"></join-guild-management-page>
      </el-tab-pane>
      <el-tab-pane :label="$t('m.leave_agency_apply')" name="quit">
        <quit-guild-approval-page v-if="shouldTabShow('quit')"></quit-guild-approval-page>
      </el-tab-pane>
      <el-tab-pane :label="$t('m.transfer-approval')" name="transfer">
        <trabsfer-audit-page v-if="shouldTabShow('transfer')"></trabsfer-audit-page>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>

import joinGuildManagementPage from './joinGuildManagementPage';
import quitGuildApprovalPage from './quitGuildApprovalPage';
import trabsferAuditPage from './transferAuditPage.vue'
export default {
  name: 'anchor-management-menu',

  components: {
    'join-guild-management-page': joinGuildManagementPage,
    'quit-guild-approval-page': quitGuildApprovalPage,
    'trabsfer-audit-page' : trabsferAuditPage
  },

  data() {
    return {
      // 默认H5活动发布页
      activeTabName: 'join'
    };
  },

  methods: {
    shouldTabShow(tabName) {
      return this.activeTabName === tabName;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/pages/anchor/AnchorManagement.vue